/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lost_Slow_Elk_EarnInputs */

const fr_lost_slow_elk_earn = /** @type {(inputs: Lost_Slow_Elk_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant unique utilisé dans les URLs (généré automatiquement)`)
};

/**

* @param {Lost_Slow_Elk_EarnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lost_slow_elk_earn = /** @type {((inputs?: Lost_Slow_Elk_EarnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lost_Slow_Elk_EarnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lost_slow_elk_earn(inputs)
});